import {registerBlockType} from "@wordpress/blocks"
import 'animate.css';
const { RichText,  ColorPalette,  InspectorControls,  BlockControls,  AlignmentToolbar,  withColors,  FontSizePicker, getColorClassName, PanelColorSettings
} = wp.blockEditor;
const { PanelBody, Button, ResponsiveWrapper, RangeControl, ToggleControl, SelectControl, TextControl} = wp.components;
const { Fragment } = wp.element;
const { __ } = wp.i18n;
const { withSelect } = wp.data;
import {	
	__experimentalBoxControl as BoxControl, BaseControl, __experimentalInputControl as InputControl, TextareaControl
} from '@wordpress/components';
import {fontfamilylist} from "./lib/fontfamilylist.js";

const BlockEdit = (props) => {
	
	const { attributes, setAttributes, clientId } = props;
	const{uniqueid, content, dropCap, contentColor, bgColor, margins, paddings, dropcapmargins, dropcappaddings, fontfamily, contentfontSize, ContentLineHeight, ContentFontWeight, ContentTransform, ContentDecoration, ContentLetterSpacing, dropcapfontfamily, dropcapfontSize, dropcapLineHeight, dropcapFontWeight, dropcapTransform, dropcapDecoration, dropcapLetterSpacing, dropColor, dropbgColor, hidedesktop, hidetablet, hidemobile, animation, durations, delay, addclass, customcss }=attributes;	
	const blockclass='spice-blocks-text-editor';
	const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
	const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
	const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
	const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
	const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
	const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
	const dropcapclass=(dropCap != false) ? 'has-dropcap':'';

	function setContent(value) {
		setAttributes({content:value});
	}
	function setContentColor(value) {
		setAttributes({contentColor:value});
	}
	function setBgColor(value) {
		setAttributes({bgColor:value});
	}
	function setdropColor(value) {
		setAttributes({dropColor:value});
	}
	function setdropbgColor(value) {
		setAttributes({dropbgColor:value});
	}
	function setPaddings(value){
		setAttributes({
			paddings: 
			{
				top: value,
				left: value,
				right: value,
				bottom: value
			}
		})			
	}	

	setAttributes({ uniqueid: 'spiceEditor' +clientId.slice(0,8) });
		

	if(fontfamily !=null){
		let url = 'https://fonts.googleapis.com/css2?family='+fontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }else{
      	document.head.appendChild(link);
      }
    }
    if(dropcapfontfamily !=null){
		let url = 'https://fonts.googleapis.com/css2?family='+dropcapfontfamily+':wght@100;200;300;400;500;600;700;800;900&display=swap';
         let link = document.createElement('link')
          link.href = url;
          link.rel = "stylesheet";
          link.type =  "text/css";
          
          if ( jQuery("body").hasClass("site-editor-php") ) { 
          jQuery('iframe').contents().find("head").append(link);
      }else{
      	document.head.appendChild(link);
      }
    }
   
		return(
			<Fragment>
				<InspectorControls>
					<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
						
						<BoxControl 
							label={__('Margin','spice-blocks')}
							inputProps={{ min: -300 }}
							values={margins}
							sides={['top', 'bottom','left','right']}
							allowReset={false}
							units={[]}
							onChange={(newValue) =>
								setAttributes({
									...margins,
									margins: {
										top: newValue.top,
										left: newValue.left,
										right: newValue.right,
										bottom: newValue.bottom,
									},
								})
							}
						/>

	          			<BoxControl
							label={__('Padding','spice-blocks')}
							values={paddings}
							units={[]}
							allowReset={false}
							onChange={(newValue) =>
								setAttributes({
									...paddings,
									paddings: {
										top: newValue.top,
										left: newValue.left,
										right: newValue.right,
										bottom: newValue.bottom,
									},
								})
							}
						/>

						<ToggleControl
							label={__('Enable/Disable Dropcap','spice-blocks')}
							checked={dropCap}
							onChange={(newval) => setAttributes({ dropCap: newval })}
						/>
						
						<BoxControl 
							label={__('Dropcap Margin','spice-blocks')}
							inputProps={{ min: -300 }}
							values={dropcapmargins}
							sides={['top', 'bottom','left','right']}
							allowReset={false}
							units={[]}
							onChange={(newValue) =>
								setAttributes({
									...dropcapmargins,
									dropcapmargins: {
										top: newValue.top,
										left: newValue.left,
										right: newValue.right,
										bottom: newValue.bottom,
									},
								})
							}
						/>
	          			<BoxControl							
							label={__('Dropcap Padding','spice-blocks')}
							values={dropcappaddings}
							units={[]}
							allowReset={false}
							onChange={(newValue) =>
								setAttributes({
									...dropcappaddings,
									dropcappaddings: {
										top: newValue.top,
										left: newValue.left,
										right: newValue.right,
										bottom: newValue.bottom,
									},
								})
							}
						/>
							
						<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>
							<ToggleControl
								label={__('Enable/Disable on Desktop','spice-blocks')}
								checked={hidedesktop}
								onChange={(newval) => setAttributes({ hidedesktop: newval })}
							/>
							<ToggleControl
								label={__('Enable/Disable on Tablet','spice-blocks')}
								checked={hidetablet}
								onChange={(newval) => setAttributes({ hidetablet: newval })}
							/>
							<ToggleControl
								label={__('Enable/Disable on Mobile','spice-blocks')}
								checked={hidemobile}
								onChange={(newval) => setAttributes({ hidemobile: newval })}
							/>
						</PanelBody>
						<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>    
			        		<SelectControl
				            label={__('Animation','spice-blocks')}
				            value={ animation }
				            options={ [
				            	{ label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
			            	] }
			            	onChange={ (newtext) => setAttributes({ animation: newtext }) }					  
			        	/>  
				        { animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>
				</PanelBody>
				
				<PanelBody initialOpen={false}	title={__('Color & Background Settings','spice-blocks')}>
					<PanelColorSettings  className={'spice-blocks-color-style'}
						colorSettings={[
							{
								value: contentColor,
								enableAlpha:true,
								clearable: true,
								onChange: setContentColor,
								label: __('Text','spice-blocks')
							},
							{
								value: bgColor,
								enableAlpha:true,
								clearable: true,
								onChange: setBgColor,
								label: __('Background','spice-blocks')
							},
							{
								value: dropColor,
								enableAlpha:true,
								clearable: true,
								onChange: setdropColor,
								label: __('Dropcap','spice-blocks')
							},
							{
								value: dropbgColor,
								enableAlpha:true,
								clearable: true,
								onChange: setdropbgColor,
								label: __('Dropcap Backgroud','spice-blocks')
							},
						]}
					/>
				</PanelBody>
					
				<PanelBody initialOpen={false} title={__('Typography Settings','spice-blocks')} className={"spicetexteditortypo"} >
					<PanelBody initialOpen={false} title={__('Content Typography Settings','spice-blocks')} >
						<SelectControl
				            label={__(' Font Family','spice-blocks')}
				            value={ fontfamily }
				            options={fontfamilylist}
				            onChange={ (newtext) => setAttributes({ fontfamily: newtext }) }
				        />
				        <FontSizePicker 
				        	__nextHasNoMarginBottom
				            value={ contentfontSize }
				            onChange={(userVal) => setAttributes({
										contentfontSize: userVal
									})}
				        />
				        <SelectControl
				            label={__('Font Weight','spice-blocks')}
				            value={ ContentFontWeight }
				            options={ [
				                { label: __('Thin','spice-blocks'), value: '100' },
				                { label: __('Extra Light','spice-blocks'), value: '200' },
				                { label: __('Light','spice-blocks'), value: '300' },
				                { label: __('Regular','spice-blocks'), value: '400' },
				                { label: __('Medium','spice-blocks'), value: '500' },
				                { label: __('Semi Bold','spice-blocks'), value: '600' },
				                { label: __('Bold','spice-blocks'), value: '700' },
				                { label: __('Extra Bold','spice-blocks'), value: '800' },
				                { label: __('Black','spice-blocks'), value: '900' },
				            ] }
				            onChange={ (newtext) => setAttributes({ ContentFontWeight: newtext }) }					  
				        />
				        <RangeControl 
							label={__('line Height(px)','spice-blocks')}			    
						    value={ ContentLineHeight}
				        	onChange={(newtext) => setAttributes({ ContentLineHeight: newtext })}
							min={0}
							step={0.1}
							max={100}
						/>
						<SelectControl
				            label={__('Transform','spice-blocks')}
				            value={ ContentTransform }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
				                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
				                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
				            ] }
				            onChange={ (newtext) => setAttributes({ ContentTransform: newtext }) }					  
			        	/>

				        <SelectControl
				            label={__('Decoration ','spice-blocks')}
				            value={ ContentDecoration }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Underline','spice-blocks'), value: 'underline' },
				                { label: __('Overline','spice-blocks'), value: 'overline' },
				                { label: __('Line Through','spice-blocks'), value: 'line-through' },
				            ] }
				            onChange={ (newtext) => setAttributes({ ContentDecoration: newtext }) }					  
				        />

				        <RangeControl 
							label={__('Letter Spacing','spice-blocks')}			    
						    value={ ContentLetterSpacing}
				        	onChange={(newtext) => setAttributes({ ContentLetterSpacing: newtext })}
							min={-10}
							step={0.1}
							max={10}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={__('Dropcap Typography Settings','spice-blocks')} >
						<SelectControl
				            label={__(' Font Family','spice-blocks')}
				            value={ dropcapfontfamily }
				            options={fontfamilylist}
				            onChange={ (newtext) => setAttributes({ dropcapfontfamily: newtext }) }
				        />	
				        <FontSizePicker
				        	__nextHasNoMarginBottom 
				            value={ dropcapfontSize }
				            onChange={(userVal) => setAttributes({
										dropcapfontSize: userVal
									})}
				        />
				        <SelectControl
				            label={__('Font Weight','spice-blocks')}
				            value={ dropcapFontWeight }
				            options={ [
				                { label: __('Thin','spice-blocks'), value: '100' },
				                { label: __('Extra Light','spice-blocks'), value: '200' },
				                { label: __('Light','spice-blocks'), value: '300' },
				                { label: __('Regular','spice-blocks'), value: '400' },
				                { label: __('Medium','spice-blocks'), value: '500' },
				                { label: __('Semi Bold','spice-blocks'), value: '600' },
				                { label: __('Bold','spice-blocks'), value: '700' },
				                { label: __('Extra Bold','spice-blocks'), value: '800' },
				                { label: __('Black','spice-blocks'), value: '900' },
				            ] }
				            onChange={ (newtext) => setAttributes({ dropcapFontWeight: newtext }) }					  
				        />
				        <RangeControl 
							label={__('line Height(px)','spice-blocks')}			    
						    value={ dropcapLineHeight}
				        	onChange={(newtext) => setAttributes({ dropcapLineHeight: newtext })}
							min={0}
							step={0.1}
							max={100}
						/>
						<SelectControl
				            label={__('Transform','spice-blocks')}
				            value={ dropcapTransform }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Uppercase','spice-blocks'), value: 'uppercase' },
				                { label: __('Lowercase','spice-blocks'), value: 'lowercase' },
				                { label: __('Capitalize','spice-blocks'), value: 'capitalize' },
				            ] }
				            onChange={ (newtext) => setAttributes({ dropcapTransform: newtext }) }					  
			        	/>

				        <SelectControl
				            label={__('Decoration ','spice-blocks')}
				            value={ dropcapDecoration }
				            options={ [
				                { label: __('Default','spice-blocks'), value: '' },
				                { label: __('Underline','spice-blocks'), value: 'underline' },
				                { label: __('Overline','spice-blocks'), value: 'overline' },
				                { label: __('Line Through','spice-blocks'), value: 'line-through' },
				            ] }
				            onChange={ (newtext) => setAttributes({ dropcapDecoration: newtext }) }					  
				        />

				        <RangeControl 
							label={__('Letter Spacing','spice-blocks')}			    
						    value={ dropcapLetterSpacing}
				        	onChange={(newtext) => setAttributes({ dropcapLetterSpacing: newtext })}
							min={-10}
							step={0.1}
							max={10}
						/>
					</PanelBody>
		        </PanelBody>
		        <PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
                    <InputControl
                        label={__('Additional Class','spice-blocks')}
                        value={ addclass }
                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
                    />
                    <TextareaControl
                        label={__('Custom CSS','spice-blocks')}
                        value={ customcss }
                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
                    />
                </PanelBody>        				

			</InspectorControls>
			<BlockControls>
				<AlignmentToolbar
					value={attributes.textAlignment}
					onChange={(newalign) => setAttributes({ textAlignment: newalign })}
				/>
			</BlockControls>
			<style dangerouslySetInnerHTML={{
			  __html: [
			     `.text-editor-inner p.${uniqueid}.has-dropcap:first-child:first-letter {
					color: ${dropColor};
					background-color:${dropbgColor};
					float: left;
					font-family: ${dropcapfontfamily};
					font-size: ${dropcapfontSize};
					text-transform:${dropcapTransform};
					text-decoration:${dropcapDecoration};
					font-weight: ${dropcapFontWeight};
					line-height: ${dropcapLineHeight}px;
					letter-spacing: ${dropcapLetterSpacing}px;
					margin: ${dropcapmargins.top} ${dropcapmargins.right} ${dropcapmargins.bottom} ${dropcapmargins.left};
					padding: ${dropcappaddings.top} ${dropcappaddings.right} ${dropcappaddings.bottom} ${dropcappaddings.left};
				}
				${customcss}`
			    ].join('\n')
			  }}>
			</style>
			<div class="text-editor-inner">
				<RichText
					key="editable"
					tagName="p"
					className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass} ${dropcapclass} ${uniqueid} ${addclass}`}
					placeholder={__('Enter Text Here','spice-blocks')}
					value={content}
					onChange={setContent}
					style={{color:contentColor,
								backgroundColor:bgColor,
								margin: `${margins.top} ${margins.right} ${margins.bottom} ${margins.left}`,
								padding: `${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left}`,								
								fontSize: contentfontSize,
							  fontWeight: ContentFontWeight,
							  lineHeight: `${ContentLineHeight}px`,
							  animationDelay: delay+ 'ms',
							  fontFamily:fontfamily,
							  textTransform:ContentTransform,
							  textDecoration:ContentDecoration,
							  letterSpacing:ContentLetterSpacing,
							}}
				/>
				</div>
		</Fragment>
	);
};
 

registerBlockType('spice-blocks/spice-text-editor',{

	title:__('Text Editor','spice-blocks'),
	icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><linearGradient id="a" x1="53.862" x2="458.25" y1="113.412" y2="517.8" gradientTransform="matrix(1 0 0 -1 0 514)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#332c81"/><stop offset="1" stop-color="#e21d73"/></linearGradient><path fill="#09A223" d="M460.6 6H51.4c-9.9 0-17.9 8-17.9 17.9V131c0 9.9 8 17.9 17.9 17.9h35.7c9.9 0 17.9-8 17.9-17.9V95.3h106.4v339.3h-44.6c-9.9 0-17.9 8-17.9 17.9v35.7c0 9.9 8 17.9 17.9 17.9h178.6c9.9 0 17.9-8 17.9-17.9v-35.7c0-9.9-8-17.9-17.9-17.9h-44.6V95.3h106.4V131c0 9.9 8 17.9 17.9 17.9h35.7c9.9 0 17.9-8 17.9-17.9V23.9C478.5 14 470.5 6 460.6 6z"/></svg>,
	category:'spice-blocks',
	example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
	keywords:['Spice Text Editor','Text Editor','Editor'],
	supports: {
		html: false,
		anchor: true,
		spacing: {
    margin: true,
    padding: true,
    }
	},
	attributes:{
		uniqueid:{
			type:'string'
		},
		content:{
			type:'string',
		},
		dropCap:{
			type: 'boolean',
			default: false
		},
		textAlignment: {
			type: 'string',
			default:'left'
		},
		contentColor:{
			type:'string',
		},
		bgColor:{
	    	type:'string',
	    },
	    dropColor:{
	    	type:'string',
	    },
	    dropbgColor:{
	    	type:'string',
	    },
		margins: {
	        default: {
	            top: '0px',
	            left: '0px',
	            right: '0px',
	            bottom: '0px'
	        }
    	},
		paddings:{
			type: 'object',
	      	default: {
		        top: '0px',
		        left: '0px',
		        right: '0px',
		        bottom: '0px',
	      	},
		},
		dropcapmargins: {
	        default: {
	            top: '10px',
	            left: '10px',
	            right: '10px',
	            bottom: '10px'
	        }
    	},
		dropcappaddings:{
			type: 'object',
	      	default: {
		        top: '8px',
		        left: '12px',
		        right: '12px',
		        bottom: '8px',
	      	},
		},
	    hidedesktop:{
	    	type: 'boolean',
			default: true
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: true
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: true
	    },
	    animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    },
	    fontfamily:{
	    	type:'string',
	    	default:'Open Sans',
	    },
		ContentFontWeight:{
			type:'string',
			default:400
		},
   		ContentLineHeight:{
	    	type:'number',
	    	default:28
    	}, 	    
	    ContentTransform:{
	    	type:'string'
	    },
	    ContentDecoration:{
	    	type:'string'
	    },
	    ContentLetterSpacing:{
	    	type:'number'
	    },
	    contentfontSize:{
	    	type:'string',
	    	default:'18px'
	    },
	    dropcapfontfamily:{
	    	type:'string',
	    	default:'Open Sans',
	    },
		dropcapFontWeight:{
			type:'string',
			default:600
		},
   		dropcapLineHeight:{
	    	type:'number',
	    	default:60
    	},	    
	    dropcapTransform:{
	    	type:'string',
	    	default:'uppercase'
	    },
	    dropcapDecoration:{
	    	type:'string'
	    },
	    dropcapLetterSpacing:{
	    	type:'number'
	    },
	    dropcapfontSize:{
	    	type:'string',
	    	default:'72px'
	    },
	    addclass:{
	    	type:'string',
	    },
	    customcss:{
	    	type:'string',
	    }
	},

	edit:BlockEdit,

	save:(props)=>{
		const { attributes } = props;
		const{uniqueid, fontfamily, content, dropCap, contentColor, bgColor, margins, paddings, dropcapmargins, dropcappaddings, contentfontSize, ContentLineHeight, ContentFontWeight, ContentTransform, ContentDecoration, ContentLetterSpacing, dropcapfontfamily, dropcapfontSize, dropcapLineHeight, dropcapFontWeight, dropcapTransform, dropcapDecoration, dropcapLetterSpacing, dropColor, dropbgColor, hidedesktop, hidetablet, hidemobile, animation, durations, delay, addclass, customcss}=attributes;
		const blockclass='spice-blocks-text-editor';
		const alignmentClass = (attributes.textAlignment != null) ? 'has-text-align-' + attributes.textAlignment : '';
		const animationclass='wow animated '+attributes.durations+' '+attributes.animation;
		const displaydesktop=(hidedesktop == false) ? 'hide-desktop' : '';
		const displaytablet=(hidetablet == false) ? 'hide-tablet' : '';
		const displaymobile=(hidemobile == false) ? 'hide-mobile' : '';
		const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
		const dropcapclass=(dropCap != false) ? 'has-dropcap':'';

		return(
			<>	
			<style dangerouslySetInnerHTML={{
			  __html: [
			     `.text-editor-inner p.${uniqueid}.has-dropcap:first-child:first-letter {
						color: ${dropColor};
						background-color:${dropbgColor};
						float: left;
						font-family: ${dropcapfontfamily};
						font-size: ${dropcapfontSize};
						font-weight: ${dropcapFontWeight};
						text-transform:${dropcapTransform};
						text-decoration:${dropcapDecoration};
						line-height: ${dropcapLineHeight}px;
						letter-spacing: ${dropcapLetterSpacing}px;
						margin: ${dropcapmargins.top} ${dropcapmargins.right} ${dropcapmargins.bottom} ${dropcapmargins.left};
						padding: ${dropcappaddings.top} ${dropcappaddings.right} ${dropcappaddings.bottom} ${dropcappaddings.left};
							}
					${customcss}`
			    ].join('\n')
			  }}>
			</style>
			<script> 
				var fontfamily2=`{fontfamily}`;
				var url2 = 'https://fonts.googleapis.com/css2?family='+fontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var link2 = document.createElement('link');
				link2.href = url2;
				link2.rel = "stylesheet";
				link2.type =  "text/css";	          
				document.head.appendChild(link2);
				
				var dropcapfontfamily2=`{dropcapfontfamily}`;				
				var dropcapfontfamilyurl2 = 'https://fonts.googleapis.com/css2?family='+dropcapfontfamily2+':wght@100;200;300;400;500;600;700;800;900&display=swap';
				var dropcapfontfamilylink2 = document.createElement('link');
				dropcapfontfamilylink2.href = dropcapfontfamilyurl2;
				dropcapfontfamilylink2.rel = "stylesheet";
				dropcapfontfamilylink2.type =  "text/css";	          
				document.head.appendChild(dropcapfontfamilylink2);
			</script>
			<div className='text-editor-inner'>					
				<RichText.Content 
					tagName="p"
					className={`${blockclass} ${alignmentClass} ${animationclass} ${displayclass} ${dropcapclass} ${uniqueid} ${props.attributes.className} ${addclass}`}
					value={attributes.content}
					style={{color:contentColor,
						backgroundColor:bgColor,
						margin: `${margins.top} ${margins.right} ${margins.bottom} ${margins.left}`,
						padding: `${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left}`,								
						fontSize: contentfontSize,
						fontWeight: ContentFontWeight,
						lineHeight: `${ContentLineHeight}px`,
						animationDelay: delay+ 'ms',
						fontFamily:fontfamily,
						textTransform:ContentTransform,
						textDecoration:ContentDecoration,
						letterSpacing:ContentLetterSpacing,
					}}
				/>
			</div>
			</>
		)
	}
})